import React, { useEffect, useRef, useState } from "react";
import FormInput from "../../components/Input/FormInput";
import Input from "../../components/Input/Input";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import DateofBirth from "../../components/Input/DateofBirth";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Location from "../../components/Input/Location";
import axiosInstance from "../../services/api/axiosInstance";
import { IoIosInformationCircleOutline } from "react-icons/io";
import Cookie from "js-cookie";
import Modal from 'react-bootstrap/Modal';
import JsonData from "utils/JsonData";
import Select from "react-dropdown-select";
import { decryptData, encryptData } from "Security/Crypto/Crypto";


const ProfessionalSocialMediaForm = () => {

  const queryParams = new URLSearchParams(window.location.search);
  const { jsonOnly } = JsonData();
  const [functional_specialization, set_functional_specialization] = useState(jsonOnly?.functional_specialization)
  const [mode_of_communication, set_mode_of_communication] = useState(jsonOnly?.mode_of_communication)
  const [isValidated, setIsValidated] = useState(false)
  const pageRender = useNavigate();
  const navigate = useNavigate();
  const from = "/professional/home";
  const formRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userNativeCountry, setUserNativeCountry] = useState("")
  const [userCurrentCountry, setUserCurrentCountry] = useState("")
  const [locationFieldEmpty, setLocationFieldEmpty] = useState(false)
  const [emailNotAvailableModal, setEmailNotAvailableModal] = useState(false)
  const [submitted, setSubmitted] = useState(false);
  const [ageVerified, setAgeVerified] = useState(false)
  const [agreeTerms, setAgreeTerms] = useState(false)
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState('us')
  const [dialCode, setDialCode] = useState("")

  const [location, setLocation] = useState({
    city: "",
    country: "",
  });

  const [professionalSignupInputValues, setProfessionalSignupInputValues] = useState({
    firstName: "",
    lastName: "",
    emailID: "",
    countryCode: "",
    mobileNumber: "",
    dateOfBirth: "",
    country: "",
    city: "",
    file: {},
    login_mode: ""
  });

  const professionalSignupInputs = [
    {
      id: 1,
      name: "firstName",
      type: "text",
      placeholder: "First Name",
      label: "First Name",
      errorMessage: "Please enter a valid first name",
      required: true,
      className: "form-control",
      dataTestid: "firstName",
      role: "firstName",
      alt: "firstName",
      value: professionalSignupInputValues?.firstName
    },
    {
      id: 2,
      name: "lastName",
      type: "text",
      placeholder: "Lastname",
      label: "Last Name",
      errorMessage: "Please enter a valid last name",
      required: true,
      className: "form-control",
      dataTestid: "lastName",
      alt: "lastName",
      value: professionalSignupInputValues?.lastName
    },
    {
      id: 3,
      name: "emailID",
      type: "email",
      placeholder: "Email",
      label: "Email",
      errorMessage: "Please enter a valid email",
      required: true,
      className: "form-control",
      alt: "emailID",
      dataTestid: "emailID",
      value: professionalSignupInputValues?.emailID
    },
    {
      id: 4,
      name: "mobileNumber",
      type: "number",
      placeholder: "Mobile Number",
      label: "Mobile Number",
      required: true,
      className: "form-control",
      errorMessage: "Please enter a valid phone number",
      alt: "mobileNumber",
      pattern: "^([+]d{2})?d{10}$",
      dataTestid: "mobileNumber",
      value: professionalSignupInputValues?.mobileNumber
    },
    {
      id: 6,
      name: "location",
      type: "text",
      placeholder: "Location",
      label: "Location",
      required: true,
      className: "form-control",
      errorMessage: "Please select a location",
      pattern: "^.{4,}",
      alt: "location",
      dataTestid: "location",
      value: location
    },
    {
      id: 7,
      name: "upload_resume",
      type: "file",
      placeholder: "Upload Your Resume",
      label: "Upload Your Resume",
      className: "form-control",
      errorMessage: "Please select a location from the drop-down menu",
      alt: "location",
      dataTestid: "location",
      value: professionalSignupInputValues?.file
    },
    {
      id: 8,
      name: "select_box",
      options: [{ value: 1, label: "Yes" }, { value: 2, label: "No" }],
      placeholder: "Willing to relocate",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          willing_to_relocate: values,
        })
      },
      values: professionalSignupInputValues?.willing_to_relocate || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 9,
      name: "Years of experirence",
      type: "text",
      placeholder: "Years of experirence",
      label: "Years of experirence",
      required: true,
      className: "form-control",
      alt: "Years of experirence",
      dataTestid: "Years of experirence",
    },
    {
      id: 10,
      name: "select_box",
      options: jsonOnly?.gender,
      placeholder: "Gender",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          gender: values,
        })
      },
      values: professionalSignupInputValues?.gender || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 11,
      name: "select_box",
      options: functional_specialization,
      placeholder: "Functional Specification",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          functional_speci: values,
        })
      },
      values: professionalSignupInputValues?.functional_speci || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 12,
      name: "Others",
      show: professionalSignupInputValues?.functional_speci?.length ? professionalSignupInputValues?.functional_speci[0]?.label === "Others" : false,
      placeholder: "Others",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (e) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          functional_speci_others: e.target.value,
        })
      },
      values: professionalSignupInputValues?.functional_speci_others || '',
      alt: "Others",
    },
    {
      id: 13,
      name: "select_box",
      options: jsonOnly?.sectors,
      placeholder: "Sector",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          sector: values,
        })
      },
      values: professionalSignupInputValues?.sector || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 14,
      name: "select_box",
      options: jsonOnly?.industry_sector,
      placeholder: "Industry sector",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          indutry_sector: values,
        })
      },
      values: professionalSignupInputValues?.indutry_sector || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 15,
      name: "select_box",
      options: jsonOnly?.register_job_type,
      placeholder: "Job Type",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          job_type: values,
        })
      },
      values: professionalSignupInputValues?.job_type || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 16,
      name: "select_box",
      options: jsonOnly?.location_preference,
      placeholder: "Work Location Preference",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          work_location_preference: values,
        })
      },
      values: professionalSignupInputValues?.work_location_preference || [],
      alt: "select_box",
      multi: false
    },
    {
      id: 17,
      name: "select_box",
      options: mode_of_communication,
      placeholder: "Mode of Communication with 2nd Careers",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (values) => {
        let update_mode_of_communication;
        if (values?.length) {
          if (values[0]?.label === "Others") {
            update_mode_of_communication = mode_of_communication?.map((v) => {
              return v?.label === "Others" ? v : { ...v, disabled: true }
            })
          } else {
            update_mode_of_communication = mode_of_communication?.map((v) => {
              return v?.label !== "Others" ? v : { ...v, disabled: true }
            })
          }
          set_mode_of_communication(update_mode_of_communication)
        } else {
          update_mode_of_communication = mode_of_communication?.map((v) => {
            return { ...v, disabled: false }
          })

          set_mode_of_communication(update_mode_of_communication)
        }

        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          mode_of_communi: values,
        })
      },
      values: professionalSignupInputValues?.mode_of_communi || [],
      alt: "select_box",
      multi: true
    },
    {
      id: 18,
      name: "Others",
      show: professionalSignupInputValues?.mode_of_communi?.length ? professionalSignupInputValues?.mode_of_communi[0]?.label === "Others" : false,
      placeholder: "Others",
      className: "rounded-2 custom_react_dropdown react-dropdown-select-single py-2",
      change: (e) => {
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          mode_of_communi_others: e.target.value,
        })
      },
      values: professionalSignupInputValues?.mode_of_communi_others || '',
      alt: "Others",
    },
  ];

  useEffect(() => {
    const data = queryParams.get("data");
    const first_name = queryParams.get("first_name");
    const last_name = queryParams.get("last_name");
    const email_id = queryParams.get("email_id");
    const login_mode = queryParams.get("mode");
    var uri = window.location.toString();

    if (uri.indexOf("?") > 0) {
      if (data) {
        let decryptedData = decryptData(data)
        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          firstName: decryptedData?.first_name || '',
          lastName: decryptedData?.last_name || '',
          emailID: decryptedData?.email_id || '',
          login_mode: decryptedData?.login_mode || '',
        })
        return
      }

      if (first_name || last_name || email_id || login_mode) {
        let encryptedParams = {
          first_name: first_name || '',
          last_name: last_name || '',
          email_id: email_id || '',
          login_mode: login_mode || '',
          encrypted: true
        }

        setProfessionalSignupInputValues({
          ...professionalSignupInputValues,
          firstName: first_name,
          lastName: last_name,
          emailID: email_id,
          login_mode: login_mode
        })

        const newUrl = `/role_selection/professional_signup/social_media?data=${encryptData(encryptedParams)}`;
        window.history.replaceState({}, document.title, newUrl);
      }
    }
  }, []);

  const handlePhoneInput = (e, phone, contactno) => {
    setUserNativeCountry(phone.name)

    setProfessionalSignupInputValues({
      ...professionalSignupInputValues,
      mobileNumber: e.slice(phone.dialCode.length),
      countryCode: phone.dialCode,
    });

    setCountryCode(phone.dialCode)
    setDialCode(phone.dialCode)
  };

  const handleLocation = (selectedLocation) => {
    const countryComponent = selectedLocation.find(component => component.types.includes('country'));

    if (countryComponent) {
      setUserCurrentCountry(countryComponent.long_name)

      if (selectedLocation) {
        setLocation({
          city: selectedLocation[0].long_name,
          country: countryComponent.long_name,
        });
      }
    }
  };

  const handleCreateAccount = async (e) => {
    e.preventDefault();
    setIsValidated(true)

    if (professionalSignupInputValues.firstName === "" ||
      professionalSignupInputValues.lastName === "" ||
      professionalSignupInputValues.emailID !== "" && professionalSignupInputValues.mobileNumber === "" ||
      countryCode === "us" && professionalSignupInputValues.mobileNumber === "" ||
      professionalSignupInputValues.mobileNumber === "" ||
      !(professionalSignupInputValues.file && professionalSignupInputValues.file.name) ||
      !professionalSignupInputValues?.willing_to_relocate?.length ||
      !professionalSignupInputValues?.years_of_exp ||
      !professionalSignupInputValues?.functional_speci?.length ||
      !professionalSignupInputValues?.sector?.length ||
      !professionalSignupInputValues?.indutry_sector?.length ||
      !professionalSignupInputValues?.job_type?.length ||
      !professionalSignupInputValues?.work_location_preference?.length ||
      !professionalSignupInputValues?.mode_of_communi?.length
    ) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    }

    else if ((professionalSignupInputValues?.functional_speci[0]?.label === "Others" && !professionalSignupInputValues?.functional_speci_others) ||
      (professionalSignupInputValues?.mode_of_communi[0]?.label === "Others" && !professionalSignupInputValues?.mode_of_communi_others)) {
      toast("Please fill all the details", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    }

    else if (location.country === "" || location.city === "") {
      setLocation({
        city: "",
        country: "",
      });
      setLocationFieldEmpty(true)
      toast.error('Kindly select a location from the drop-down menu')
      return
    }

    else if (
      agreeTerms === false ||
      ageVerified === false
    ) {
      toast("Please select all the checkboxes", {
        icon: (
          <IoIosInformationCircleOutline className="fs-1 brand-color me-1" />
        ),
      });
      return;
    } else {
      if (userNativeCountry.toLowerCase() === userCurrentCountry.toLowerCase()) {
        handleCreateAccountConfirmation(e)
      } else {
        document.getElementById('coutryLocationMatchModalOpen').click()
        return
      }
    }

  };

  const handleCreateAccountConfirmation = async (e) => {
    e.preventDefault();
    setIsValidated(false)

    const gender = professionalSignupInputValues?.gender?.length ? professionalSignupInputValues?.gender[0]?.label : ''
    const willing_to_relocate = professionalSignupInputValues?.willing_to_relocate[0]?.label
    const functional_specification = professionalSignupInputValues?.functional_speci[0]?.label
    const sector = professionalSignupInputValues?.sector[0]?.label
    const industry_sector = professionalSignupInputValues?.indutry_sector[0]?.label
    const job_type = professionalSignupInputValues?.job_type[0]?.label
    const work_location_preference = professionalSignupInputValues?.work_location_preference[0]?.label
    const mode_of_communi = professionalSignupInputValues?.mode_of_communi?.map((v) => v?.label)?.join(",")

    setLoading(true);
    const fd = new FormData();
    fd.append("first_name", professionalSignupInputValues.firstName.trim())
    fd.append("last_name", professionalSignupInputValues.lastName.trim())
    fd.append("contact_number", professionalSignupInputValues.mobileNumber)
    fd.append("city", location.city)
    fd.append("country", location.country)
    fd.append("country_code", professionalSignupInputValues.mobileNumber === "" ? "us" : countryCode)
    fd.append("is_age_verified", ageVerified ? "Y" : "N")
    fd.append("email_id", professionalSignupInputValues.emailID)
    fd.append("file", professionalSignupInputValues?.file)
    fd.append("login_mode", professionalSignupInputValues?.login_mode)

    fd.append("gender", gender)
    fd.append("willing_to_relocate", willing_to_relocate)
    fd.append("years_of_experience", professionalSignupInputValues?.years_of_exp)
    fd.append("functional_specification", functional_specification === "Others" ? professionalSignupInputValues?.functional_speci_others : functional_specification)
    fd.append("sector", sector)
    fd.append("industry_sector", industry_sector)
    fd.append("job_type", job_type)
    fd.append("location_preference", work_location_preference)
    fd.append("mode_of_communication", mode_of_communi === "Others" ? professionalSignupInputValues?.mode_of_communi_others : mode_of_communi)

    try {
      document.getElementById('locationConfirmationModalClose').click()
      const response = await axiosInstance.post("/store_signup_details", fd)
      setLoading(false);

      if (response.data.error_code === 0) {
        Cookie.set("pToken", response.data.data.access_token, {
          secure: true,
          sameSite: 'strict',
          path: '/'
        })

        setLocationFieldEmpty(false)
        navigate(from, { replace: true });
        setSubmitted(true);
        formRef.current.reset();
        setProfessionalSignupInputValues({
          mobileNumber: null,
        });
        toast.success(response.data.message);
      } else {
        if (response.data.message == "error: \n{\"message\":\"It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile\"}\n") {
          toast.error("It looks like the document you uploaded isn't a resume. Please upload a resume so we can create your 2C profile");
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  const onChange = (e) => {
    setProfessionalSignupInputValues({
      ...professionalSignupInputValues,
      [e.target.name]: e.target.value,
    });
  };

  const onClickOne = () => {
    setShowPassword(!showPassword);
  };

  const onClickTwo = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <>
      <form
        className="row signup-forms"
        ref={formRef}
        onSubmit={handleCreateAccount}
      >
        {professionalSignupInputs.map((professionalSignupInput) => {
          return (
            <React.Fragment key={professionalSignupInput.id}>
              {professionalSignupInput.name === "mobileNumber" ?
                <div className="col-md-6 mt-2  ">
                  <div className="form-floating">
                    <PhoneInput
                      id="floatingInput"
                      specialLabel="Mobile Number"
                      country={dialCode === "" ? "us" : dialCode}
                      dataTestid="mobileNumber"
                      countryCodeEditable={false}
                      enableSearch
                      onChange={(e, phone) =>
                        handlePhoneInput(e, phone, "contactno")
                      }
                      value={`${dialCode}${professionalSignupInputValues.mobileNumber}`}
                      inputProps={{
                        alt: "mobileNumber",
                        type: "tel",
                        placeholder: "Mobile Number",
                        required: true,
                        style: { borderColor: isValidated && !professionalSignupInputValues.mobileNumber ? "red" : '' }
                      }}
                    />
                  </div>

                  <div
                    id="signup-error-message"
                    className="text-danger mt-2 signup-error-message professional-signup-error-message"
                  >
                    {professionalSignupInput.errorMessage}
                  </div>
                </div>
                :
                professionalSignupInput.name === "dateOfBirth" ?
                  <div className="col-md-6 mt-2 ">
                    <DateofBirth
                      professionalSignupInputValues={professionalSignupInputValues}
                      setProfessionalSignupInputValues={
                        setProfessionalSignupInputValues
                      }
                    />
                  </div>
                  :
                  professionalSignupInput.name === "location" ?
                    <div className="col-12 col-md-6 mt-2 location-field-container mb-3">
                      <div className={`form-floating ${locationFieldEmpty ? "border-red" : ""}`}>
                        <Location
                          location={location}
                          setLocation={setLocation}
                          handleLocation={handleLocation}
                          pattern={professionalSignupInput.pattern}
                          submitted={submitted}
                          isValidated={isValidated && !location.city && !location.country ? "red" : ''}
                          formInputFieldError={
                            (location.country.length && location.city.length) >= 3
                              ? ""
                              : professionalSignupInput.errorMessage
                          }
                        />
                      </div>
                    </div>
                    :
                    professionalSignupInput.name === "upload_resume" ?
                      <div className="col-12 col-md-6">
                        <input type="file" className="d-none" id="add_resume"
                          onChange={(e) => {
                            const file = e.target.files[0];

                            if (file && file.type !== "application/pdf") {
                              toast.error("Only PDF files are allowed!");
                              return;
                            }

                            setProfessionalSignupInputValues({
                              ...professionalSignupInputValues,
                              file: file,
                            });
                          }}
                          accept="application/pdf" />

                        <div className="input_resume w-100 d-flex flex-wrap justify-content-center"
                          onClick={() => document.getElementById("add_resume")?.click()}
                          style={{ borderColor: isValidated && !professionalSignupInputValues.file?.name ? "red" : '' }}>
                          <span className="col-9" style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'inline-block'
                          }}>
                            {
                              professionalSignupInputValues?.file?.name ?
                                professionalSignupInputValues?.file?.name
                                :
                                "Upload your resume"
                            }
                          </span>
                          <span className="col-3 text-end">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M9 17V11L7 13" stroke="#989898" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M9 11L11 13" stroke="#989898" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14" stroke="#989898" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#989898" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>

                          <span className="add_resume_label">
                            Upload Resume <span className="asterisk">&nbsp;*</span>
                          </span>
                        </div>
                      </div>
                      :
                      professionalSignupInput.name === "select_box" ?
                        <div className={`mt-2 user-form-group ${["Mode of Communication with 2nd Careers"].includes(professionalSignupInput?.placeholder) ? "col-12" : "col-12 col-md-6"}`}>
                          <Select
                            color='#ffa32d'
                            multi={professionalSignupInput?.multi}
                            options={professionalSignupInput?.options}
                            className={professionalSignupInput?.className}
                            values={professionalSignupInput?.values || []}
                            onChange={professionalSignupInput?.change}
                            dropdownPosition="auto"
                            style={{ borderColor: isValidated && !professionalSignupInput?.values?.length && professionalSignupInput?.placeholder !== "Gender" ? "red" : '' }}
                          />

                          <span className="add_floating_label">
                            {professionalSignupInput?.placeholder}
                            {
                              professionalSignupInput?.placeholder !== "Gender" ?
                                <span className="asterisk">&nbsp;*</span>
                                :
                                null
                            }
                          </span>
                        </div>
                        :
                        professionalSignupInput?.name === "Others" ?
                          professionalSignupInput?.show ?
                            <div className="col-12 mb-2 user-form-group">
                              <textarea className="form-control" rows={3}
                                style={{ borderColor: isValidated && !professionalSignupInput?.values ? "red" : '' }} value={professionalSignupInput?.value}
                                onChange={professionalSignupInput?.change}
                              />

                              <span className="add_floating_label">
                                {professionalSignupInput?.placeholder}
                                <span className="asterisk">&nbsp;*</span>
                              </span>
                            </div>
                            :
                            null
                          :
                          professionalSignupInput.name === "Years of experirence" ?
                            <div className="col-12 col-md-6 mt-2 user-form-group">
                              <input
                                type="text"
                                name={professionalSignupInput.name}
                                className="w-100 form-control py-2 pb-3"
                                value={professionalSignupInputValues?.years_of_exp || ''}
                                style={{ borderColor: isValidated && !professionalSignupInputValues?.years_of_exp ? "red" : '' }}
                                onChange={(e) => {
                                  if (/^\d+$/.test(e.target.value) && e.target.value !== "" && Number(e.target.value) < 100 && Number(e.target.value) > 0) {
                                    setProfessionalSignupInputValues({
                                      ...professionalSignupInputValues,
                                      years_of_exp: e.target.value,
                                    });
                                  } else {
                                    if (e.target.value === "") {
                                      setProfessionalSignupInputValues({
                                        ...professionalSignupInputValues,
                                        years_of_exp: '',
                                      });
                                    }
                                  }
                                }}
                              />

                              <span className="add_floating_label">
                                {professionalSignupInput?.placeholder}
                                <span className="asterisk">&nbsp;*</span>
                              </span>
                            </div>
                            :
                            <FormInput
                              socialLoginMode={professionalSignupInputValues.emailID}
                              formInputDivClassName={
                                professionalSignupInput.name === "emailID"
                                  ? "col-md-6 col-lg-6 col-xl-6 col-xxl-6 mt-2"
                                  : "col-md-6 mt-2"
                              }
                              validated={isValidated && !professionalSignupInput?.value ? 'border-danger' : ''}
                              formInputType={professionalSignupInput.type}
                              formInputId={professionalSignupInput.name}
                              formAriaLabel={professionalSignupInput.name}
                              formFieldName={professionalSignupInput.label}
                              formInputFieldError={professionalSignupInput.errorMessage}
                              formFieldRequired={true}
                              nameFromProfessionalSignup={professionalSignupInput.name}
                              valueFromProfessionalSignup={
                                professionalSignupInputValues[professionalSignupInput.name]
                              }
                              onChange={onChange}
                              errorMessage={professionalSignupInput.errorMessage}
                              pattern={professionalSignupInput.pattern}
                              dataTestid={professionalSignupInput.dataTestid}
                              role={professionalSignupInput.role}
                              alt={professionalSignupInput.alt}
                              handleEyeClick={
                                professionalSignupInput.name === "pasemailIDsword"
                                  ? onClickOne
                                  : null || professionalSignupInput.name === "confirmPassword"
                                    ? onClickTwo
                                    : null
                              }
                              showPassword={
                                professionalSignupInput.name === "password"
                                  ? showPassword
                                  : null || professionalSignupInput.name === "confirmPassword"
                                    ? showConfirmPassword
                                    : null
                              }
                              submitted={submitted}
                              setSubmitted={setSubmitted}
                            />
              }
            </React.Fragment>
          );
        })}

        <div className="col-12 mt-2">
          <div className="form-check">
            <Input
              className="form-check-input"
              type="checkbox"
              id="termsAndCondition"
              required={true}
              alt="checkbox"
              functionOnchange={(e) => setAgreeTerms(e.target.checked)}
            />

            <label className="form-check-label" htmlFor="invalidCheck">
              I agree to all the&nbsp;
              <a onClick={() => window.open("https://2ndcareers.com/terms-and-conditions/", "_blank")} className="text-decoration-none">
                Terms&nbsp;
              </a>{" "}
              and&nbsp;
              <a onClick={() => window.open("https://2ndcareers.com/privacy-policy/", "_blank")} className="text-decoration-none">
                {" "}
                Privacy policy
              </a>
            </label>
          </div>
        </div>

        <div className="col-12 mt-2">
          <div className="form-check">
            <Input
              className="form-check-input"
              type="checkbox"
              id="termsAndCondition"
              required={true}
              functionOnchange={(e) => setAgeVerified(e.target.checked)}
              alt="checkbox"
            />

            <label className="form-check-label" htmlFor="invalidCheck">
              I confirm that I am over 45 years of age
            </label>
          </div>
        </div>

        <div className="d-grid mt-2">
          <button
            type="submit"
            className="btn btn-brand-color"
            id="createSocialAccount"
            disabled={loading}
          >
            {loading ? "Loading..." : "Create Account"}
          </button>
        </div>
      </form>

      <div type="button" id="coutryLocationMatchModalOpen" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#coutryLocationMatchModal">
        Launch demo modal
      </div>

      <div className="modal fade" id="coutryLocationMatchModal" tabIndex="-1" aria-labelledby="coutryLocationMatchModal" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <h1 className="modal-title fs-5" id="coutryLocationMatchModal">
                <IoIosInformationCircleOutline className="fs-2 brand-color me-3" />
                Location Confirmation
              </h1>
              <button type="button" className="btn-close opacity-0" id="locationConfirmationModalClose" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body mb-5 ms-3">
              There seems to be a mismatch between your location and phone country code. Do you wish to continue?
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary w-25" data-bs-dismiss="modal">No</button>
              <button type="button" className="btn btn-brand-color w-25" onClick={(e) => handleCreateAccountConfirmation(e)}>Yes</button>
            </div>
          </div>



          <Modal
            show={emailNotAvailableModal}
            backdrop="static"
            keyboard={false}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName="rounded-4"
          >
            <Modal.Body>
              <div className="py-4 px-2 col-12">
                <div className="row justify-content-center col-12 text-center">
                  {/* <div className="col-6 text-center">
                  <img src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}subscription-expired.png`} alt='subscription expired' with={135} height={135} />
                </div> */}

                  <div className="col-12">
                    <div className="py-2">
                      <div className="d-flex align-items-center justify-content-center mb-3">
                        <p className="mb-0"><IoIosInformationCircleOutline className="fs-3 brand-color me-2" /></p>
                        <h5 className="mb-0"> Please Don’t Hide Your Email</h5>
                      </div>
                    </div>
                    <p className="text-mute mb-0">It looks like you've opted to hide your email while signing up. We won’t be able to send important communications or updates if we can’t reach you. Please do not hide your email and try again.
                    </p>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="col-lg-12 d-flex justify-content-center gap-2 mx-auto">
                <button
                  id="proceedButton"
                  type="button"
                  className="btn btn-brand-color my-2  w-50"
                  onClick={() => {
                    setEmailNotAvailableModal(false)
                    pageRender("/")
                  }}
                >
                  Back to login
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default ProfessionalSocialMediaForm;
